const homelabSeries = [
  { slug: "/digital-forensics-homelab/", title: "Introduction" },
  { slug: "/digital-forensics-homelab-topology/", title: "Network Topology" },
  {
    slug: "/digital-forensics-homelab-active-directory/",
    title: "Active Directory Basics",
  },
  { slug: "/digital-forensics-homelab-sysvol/", title: "SYSVOL" },
  {
    slug: "/digital-forensics-homelab-gpos/",
    title: "Group Policy Objects",
  },
  {
    slug: "/digital-forensics-homelab-logging/",
    title: "Centralized Logging with Loki",
  },
];

export default homelabSeries;
